import React, {Component} from 'react';
import {toolWidth} from "../../twoLinesEditorToolsSpace";
import middleLineIcon from "./middleLine.png";
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

class MiddleLineTool extends Component {

    constructor(props) {
        super(props);
        this.state = {
            btnChecked:false
        }
    }

    /**
     * 监听内容变化
     */
    listenContentChange(){
        let strikethrough = this.props.editor.queryCommandState("strikethrough");
        this.setState({btnChecked: strikethrough});
    }

    /**
     * 监听编辑器点击
     */
    listenContentClick(){
        let strikethrough = this.props.editor.queryCommandState("strikethrough");
        this.setState({btnChecked: strikethrough});
    }

    render() {
        let style = {};
        if(this.state.btnChecked && this.state.btnChecked !== -1){ //切换到源码的时候为-1
            style.boxShadow = `-1px -1px ${EDITOR_TOOL_BTN_COLOR.checked}`;
        }else{
            if(style.boxShadow){
                delete style.boxShadow;
            }
        }
        return (
            <span style={{cursor:"pointer"}} onClick={()=>{
                this.props.editor.execCommand( 'strikethrough' );
                this.setState({btnChecked:true});
            }}>
                <img className={"editor-strikethrough-tool-btn"} style={style} width={toolWidth} src={middleLineIcon} />
                <style>{`
                    .editor-strikethrough-tool-btn{
                        border: 1px solid #f2f6fc
                    }
                    .editor-strikethrough-tool-btn:hover{
                        border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                    }
                    .editor-strikethrough-tool-btn:active{
                        border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                    }
                `}</style>
            </span>
        );
    }
}

export default MiddleLineTool;